module.exports = __webpack_public_path__ + "img/bg3.30aa9e2f.png";